<app-chart-legend *ngIf="useNewLegend"></app-chart-legend>
<div class="chart-div" #chartRootElement ddvOnResize (resized)="onWrapperResized()">
    <svg #rootSvg></svg>
</div>
